import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import Chip from "../common/Chip";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
registerLocale("ko", ko);
import "src/styles/react-datepicker.css";
import { UserVo } from "src/vo/userVo";

const initVo: UserVo = {};

interface dataProps {
  filterList: StoreFilter[];
  title: string;
  changeChecked(value: StoreFilter): void;
}

const SearchFilterItemCommonV2 = (props: dataProps) => {
  const [storeList, setStoreList] = useState(props.filterList.map((res) => res.storeType));
  const [selectedStoreList, setSelectedStoreList] = useState(props.filterList.map((res) => res.storeType));

  return (
    <>
      <FilterItemSet>
        <p className="title">선택한 조건</p>
        <div>
          {props.filterList.map((value: StoreFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => props.changeChecked(value)}>
                  {value.storeType}
                </Chip>
              )
            );
          })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{props.title}</p>
        <div>
          {props.filterList.map((value: StoreFilter, index: number) => {
            const check = false;
            return (
              <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => props.changeChecked(value)}>
                {value.storeType}
              </Chip>
            );
          })}
        </div>
      </FilterItemSet>
    </>
  );
};

const FilterItemSet = styled.li`
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "wrap")}
    > div {
      margin: 15px 10px 0 0;
    }
  }
`;

const DatePickerWrap = styled.div`
  overflow: hidden;
  width: auto;
  max-width: 345px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  border: 1px solid ${({ theme }) => theme.color.lineSecondary};
  border-radius: 14px;
  padding: 0 15px;
  > .react-datepicker-wrapper {
    width: 120px;
  }
  .divide {
    position: relative;
    display: block;
    height: 28px;
    width: 20px;
    padding: 0 10px;
    margin-right: 15px;
    flex: 1;
    &::before {
      position: absolute;
      left: 0;
      top: 50%;
      content: "";
      display: block;
      width: 20px;
      height: 1px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default SearchFilterItemCommonV2;
